import { styled } from '@mui/material'
import { useIntl } from 'react-intl'
import { DependentItem } from './collectDependentWbsItemNames'

type DependencyCascadeTooltipContentProps = {
  isCtrlPressed: boolean
  dependentItems: DependentItem[]
}

export const DependencyCascadeTooltipContent = ({
  isCtrlPressed,
  dependentItems,
}: DependencyCascadeTooltipContentProps) => {
  const intl = useIntl()

  const message = isCtrlPressed
    ? intl.formatMessage({ id: 'gantt.dependency.cascade.withCtrl' })
    : intl.formatMessage({ id: 'gantt.dependency.cascade.withoutCtrl' })

  const notExpandedSuffix = intl.formatMessage({
    id: 'gantt.dependency.cascade.notExpanded',
  })

  const getTerminalStatusSuffix = (status: string) =>
    intl.formatMessage(
      { id: 'gantt.dependency.cascade.terminalStatus' },
      { status }
    )

  return (
    <TooltipContentRoot>
      <TooltipMessage>{message}</TooltipMessage>
      <TooltipList>
        {dependentItems.map((item, index) => (
          <TooltipListItem key={index}>
            ・{item.displayName}
            {item.terminalStatus &&
              getTerminalStatusSuffix(item.terminalStatus)}
            {item.isNotExpanded && notExpandedSuffix}
          </TooltipListItem>
        ))}
      </TooltipList>
    </TooltipContentRoot>
  )
}

const TooltipContentRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
})

const TooltipMessage = styled('div')({
  whiteSpace: 'pre-wrap',
  lineHeight: '1.6',
})

const TooltipListItem = styled('div')({
  lineHeight: '1.6',
})

const TooltipList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '4px',
})
